/**
 * Shared constants used by both frontend and backend.
 * Single source of truth for electoral positions, geo rules, and role configs.
 */

// ── Electoral positions ──────────────────────────────────────────────────────

export const ELECTORAL_POSITIONS = [
  "President",
  "Governor",
  "Senator",
  "House of Representatives",
  "House of Assembly",
];

// ── Geo validation rules per electoral position ──────────────────────────────

export const ROLE_GEO_RULES = {
  "President":                  { country: true,  state: false, lga: false },
  "Governor":                   { country: true,  state: true,  lga: false },
  "Senator":                    { country: true,  state: true,  lga: false },
  "House of Representatives":   { country: true,  state: true,  lga: false },
  "House of Assembly":          { country: true,  state: true,  lga: true  },
};

// Roles that support multi-LGA selection
export const MULTI_LGA_ROLES = ["House of Assembly", "House of Representatives", "Senator"];

/**
 * Validate role + geo combination.
 * @returns {string|null} Error message string if invalid, null if ok
 */
export function validateRoleGeo(role, geoCountry, geoState, geoLga, geoLgas) {
  const rules = ROLE_GEO_RULES[role];
  if (!rules) return null; // "Other" — no validation
  if (rules.country && !geoCountry) return `${role} requires a country to be selected.`;
  if (rules.state && !geoState) return `${role} requires a state/region to be selected.`;
  if (rules.lga && !geoLga && !(Array.isArray(geoLgas) && geoLgas.length > 0)) {
    return `${role} requires a local government area to be selected.`;
  }
  return null;
}

// ── Sentiment labels ─────────────────────────────────────────────────────────

export const SENTIMENT_LABELS = ["positive", "neutral", "negative"];

// ── API model constants ──────────────────────────────────────────────────────

export const VOYAGE_MODEL = "voyage-3-lite";
export const VOYAGE_API_URL = "https://api.voyageai.com/v1/embeddings";

// ── Rate limiting defaults ───────────────────────────────────────────────────

export const RATE_LIMIT_MAX = 30;
export const RATE_LIMIT_WINDOW_MS = 60 * 60 * 1000; // 1 hour

// ── Cache defaults ───────────────────────────────────────────────────────────

export const DEFAULT_CACHE_THRESHOLD = 0.85;
export const CACHE_TTL_DAYS = 30;

// ── Credits ──────────────────────────────────────────────────────────────────

export const CREDITS_PER_INTERACTION = 1;
